<img [src]="displayUrl" height="209" width="150" [ngClass] = "['card']">

